<template lang="html">
  <b-navbar class="fixed-top" toggleable="md" type="dark" variant="info">
    <div class="text-center navbar-brand-wrapper d-flex align-items-top justify-content-center">
      <router-link class="navbar-brand brand-logo" to="/">
        <svg xmlns="http://www.w3.org/2000/svg" width="178" height="30" viewBox="0 0 1220 206">
          <g id="g18" transform="matrix(1.3333333,0,0,-1.3333333,297.51124,240.82147)" fill="#3bacf0">
            <path transform="translate(-171.80737,77.848878)" d="m 0,0 c -2.028,0 -3.689,0 -5.351,0 -14.196,-0.001 -28.393,0.068 -42.587,-0.067 -2.674,-0.026 -3.39,0.728 -3.383,3.374 0.084,31.889 0.087,63.777 -0.005,95.665 -0.008,2.867 0.696,3.814 3.706,3.782 14.619,-0.154 29.241,-0.158 43.859,0.012 3.157,0.036 4.145,-0.707 4.132,-4.012 C 0.242,67.184 0.293,35.613 0.292,4.042 c 0,-1.135 0,-2.27 0,-3.535 h 50.761 c 0,1.345 0,2.483 0,3.621 0.001,14.514 0.07,29.029 -0.053,43.542 -0.025,2.969 0.729,4.02 3.898,3.985 14.724,-0.163 29.452,-0.129 44.177,0 2.817,0.024 3.624,-0.866 3.602,-3.634 -0.117,-14.725 0.009,-29.452 -0.118,-44.177 -0.023,-2.696 0.495,-3.629 3.454,-3.585 13.028,0.193 26.062,0.012 39.091,0.161 2.878,0.033 3.55,-0.943 3.528,-3.657 -0.119,-14.936 -0.13,-29.875 -0.004,-44.812 0.024,-2.762 -0.881,-3.285 -3.465,-3.26 -14.936,0.145 -29.875,0.166 -44.811,0.039 -2.585,-0.022 -3.432,0.422 -3.404,3.211 0.152,14.83 0.075,29.663 0.066,44.495 0,1.037 -0.085,2.075 -0.138,3.275 -0.663,0.118 -1.153,0.281 -1.644,0.281 -13.348,0.013 -26.698,-0.063 -40.045,0.066 -2.889,0.028 -3.789,-0.832 -3.761,-3.755 0.139,-14.83 0.002,-29.662 0.146,-44.492 0.025,-2.666 -0.872,-3.135 -3.286,-3.117 -15.042,0.116 -30.086,0.147 -45.128,0.029 -2.573,-0.02 -3.233,0.696 -3.214,3.209 C 0.056,-33.449 0,-18.828 0,-4.208 0,-2.964 0,-1.72 0,0" />
            <path transform="translate(118.5995,141.945)" d="m 0,0 -19.239,-58.809 h -14.618 l -12.938,39.822 -13.358,-39.822 H -74.687 L -94.01,0 h 14.114 L -66.622,-41.335 -52.76,0 h 12.602 L -26.716,-41.67 -13.022,0 Z" />
            <path transform="translate(171.7078,94.0571)" d="M 0,0 V -10.921 H -45.535 V 47.888 H -1.093 V 36.966 H -32.01 V 24.196 H -4.705 V 13.61 H -32.01 V 0 Z" />
            <path transform="translate(222.794,100.6103)" d="M 0,0 C 0,4.957 -3.78,7.309 -10.837,7.309 H -26.715 V -7.225 h 15.878 C -3.78,-7.225 0,-5.041 0,0 M -26.715,31.085 V 17.223 h 13.525 c 6.638,0 10.249,2.352 10.249,6.973 0,4.62 -3.611,6.889 -10.249,6.889 z M 13.694,-1.429 c 0,-10.165 -8.065,-16.046 -23.523,-16.046 h -30.413 v 58.81 h 28.733 c 14.702,0 22.263,-6.134 22.263,-15.291 0,-5.881 -3.024,-10.418 -7.813,-12.938 6.553,-2.1 10.753,-7.141 10.753,-14.535" />
            <path transform="translate(324.1234,83.1357)" d="M 0,0 -0.084,35.285 -17.39,6.217 h -6.134 L -40.746,34.529 V 0 h -12.77 v 58.809 h 11.258 L -20.247,22.264 1.429,58.809 H 12.602 L 12.77,0 Z" />
            <path transform="translate(397.7288,112.5403)" d="M 0,0 C 0,11.174 -7.897,18.819 -18.399,18.819 -28.9,18.819 -36.798,11.174 -36.798,0 c 0,-11.174 7.898,-18.819 18.399,-18.819 C -7.897,-18.819 0,-11.174 0,0 m -50.576,0 c 0,17.475 13.61,30.412 32.177,30.412 18.482,0 32.177,-12.854 32.177,-30.412 0,-17.559 -13.695,-30.413 -32.177,-30.413 -18.567,0 -32.177,12.938 -32.177,30.413" />
            <path transform="translate(475.7008,141.945)" d="m 0,0 v -58.809 h -11.174 l -29.32,35.705 V -58.809 H -53.936 V 0 h 11.258 l 29.236,-35.706 V 0 Z" />
            <path d="m 489.655,141.945 h 13.61 V 83.136 h -13.61 z" />
            <path transform="translate(529.396,130.8549)" d="M 0,0 H -18.819 V 11.09 H 32.43 V 0 H 13.611 V -47.719 H 0 Z" />
            <path transform="translate(615.1803,112.5403)" d="m 0,0 c 0,11.174 -7.898,18.819 -18.399,18.819 -10.502,0 -18.399,-7.645 -18.399,-18.819 0,-11.174 7.897,-18.819 18.399,-18.819 C -7.898,-18.819 0,-11.174 0,0 m -50.576,0 c 0,17.475 13.61,30.412 32.177,30.412 18.483,0 32.177,-12.854 32.177,-30.412 0,-17.559 -13.694,-30.413 -32.177,-30.413 -18.567,0 -32.177,12.938 -32.177,30.413" />
            <path transform="translate(663.9154,130.8549)" d="M 0,0 H -11.089 V -20.5 H 0 c 8.318,0 12.518,3.865 12.518,10.251 C 12.518,-3.78 8.318,0 0,0 M 12.771,-47.719 1.429,-31.337 H 0.757 -11.089 V -47.719 H -24.7 V 11.09 H 0.757 c 15.711,0 25.54,-8.149 25.54,-21.339 0,-8.822 -4.452,-15.291 -12.098,-18.567 l 13.189,-18.903 z" />
            <path transform="translate(137.6093,35.4699)" d="m 0,0 v -7.421 h -30.938 v 39.957 h 30.196 v -7.42 H -21.748 V 16.439 H -3.197 V 9.247 H -21.748 V 0 Z" />
            <path transform="translate(224.5343,28.0492)" d="M 0,0 -9.647,13.871 -19.122,0 H -29.74 l 14.784,20.321 -14.041,19.635 h 10.502 l 9.191,-12.957 9.019,12.957 H 9.704 L -4.224,20.663 10.674,0 Z" />
            <path transform="translate(318.9375,53.5072)" d="M 0,0 C 0,4.395 -2.855,6.964 -8.505,6.964 H -16.04 V -6.907 h 7.535 C -2.855,-6.907 0,-4.338 0,0 m 9.361,0 c 0,-8.904 -6.678,-14.442 -17.352,-14.442 h -8.049 v -11.016 h -9.247 V 14.498 H -7.991 C 2.683,14.498 9.361,8.962 9.361,0" />
            <path transform="translate(420.5888,35.4699)" d="m 0,0 v -7.421 h -30.938 v 39.957 h 30.196 v -7.42 H -21.748 V 16.439 H -3.197 V 9.247 H -21.748 V 0 Z" />
            <path transform="translate(499.5215,60.4714)" d="M 0,0 H -7.534 V -13.928 H 0 c 5.651,0 8.505,2.625 8.505,6.964 C 8.505,-2.569 5.651,0 0,0 M 8.677,-32.422 0.97,-21.292 H 0.514 -7.534 v -11.13 h -9.247 V 7.534 H 0.514 c 10.674,0 17.352,-5.536 17.352,-14.498 0,-5.993 -3.025,-10.389 -8.219,-12.615 l 8.962,-12.843 z" />
            <path transform="translate(587.1875,60.4714)" d="M 0,0 H -12.785 V 7.534 H 22.034 V 0 H 9.247 V -32.422 H 0 Z" />
          </g>
        </svg>
      </router-link>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-center ml-auto ml-lg-0">
      <b-navbar-nav class="header-links d-none d-md-flex">
        <organisation-menu/>
        <b-nav-item href="#"><i class="mdi mdi-image-filter"></i>Gallery</b-nav-item>
        <b-nav-item href="#" active><i class="mdi mdi-email-outline"></i>Inbox</b-nav-item>
        <b-nav-item href="#"><i class="mdi mdi-calendar"></i>Calendar</b-nav-item>
      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right class="preview-list">
          <template slot="button-content">
            <div class="count-indicator">
              <i class="icon mdi mdi-email-variant"></i>
              <span class="count">7</span>
            </div>
          </template>
          <b-dropdown-item class="preview-item" href="#">
            <p class="mb-0 font-weight-normal float-left">You have 4 new notifications
            </p>
            <span class="badge badge-pill badge-warning">View all</span>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item" href="#">
            <div class="preview-thumbnail">
              <div class="preview-icon bg-success">
                <i class="mdi mdi-alert-circle-outline mx-0"></i>
              </div>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-medium">Application Error</h6>
              <p class="font-weight-light small-text">
                Just now
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item" href="#">
            <div class="preview-thumbnail">
              <div class="preview-icon bg-warning">
                <i class="mdi mdi-comment-text-outline mx-0"></i>
              </div>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-medium">Settings</h6>
              <p class="font-weight-light small-text">
                Private message
              </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item" href="#">
            <div class="preview-thumbnail">
              <div class="preview-icon bg-info">
                <i class="mdi mdi-email-outline mx-0"></i>
              </div>
            </div>
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-medium">New user registration</h6>
              <p class="font-weight-light small-text">
                2 days ago
              </p>
            </div>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right class="preview-list">
          <template slot="button-content">
            <div class="count-indicator">
              <i class="icon mdi mdi-bell-outline"></i>
              <span class="count">5</span>
            </div>
          </template>
          <b-dropdown-item class="preview-item flex-wrap flex-sm-nowrap" href="#">
            <p class="mb-0 font-weight-normal float-left">You have 4 unread mails</p>
            <span class="badge badge-pill badge-warning">View all</span>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item">
            <div class="preview-thumbnail">
              <img src="../../assets/images/faces/face10.jpg" alt="image" class="img-sm profile-pic">
            </div>
            <div class="preview-item-content flex-grow py-2">
              <p class="preview-subject ellipsis font-weight-medium text-dark">Marian Garner </p>
              <p class="font-weight-light small-text"> The meeting is cancelled </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item">
            <div class="preview-thumbnail">
              <img src="../../assets/images/faces/face12.jpg" alt="image" class="img-sm profile-pic">
            </div>
            <div class="preview-item-content flex-grow py-2">
              <p class="preview-subject ellipsis font-weight-medium text-dark">David Grey</p>
              <p class="font-weight-light small-text"> The meeting is cancelled </p>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="preview-item">
            <div class="preview-thumbnail">
              <img src="../../assets/images/faces/face1.jpg" alt="image" class="img-sm profile-pic">
            </div>
            <div class="preview-item-content flex-grow py-2">
              <p class="preview-subject ellipsis font-weight-medium text-dark">Travis Jenkins</p>
              <p class="font-weight-light small-text"> The meeting is cancelled </p>
            </div>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown right class="preview-list">
          <template slot="button-content">
            <img :src="$auth.user.picture" alt="profile image" class="img-xs rounded-circle" referrerpolicy="no-referrer" />
          </template>
          <b-dropdown-item @click="$router.push('/profile/')" class="preview-item flex-wrap">Profile</b-dropdown-item>
          <b-dropdown-item @click="logout" class="preview-item flex-wrap">Signout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <button class="navbar-toggler navbar-toggler-right align-self-center" type="button" @click="collapedMobileSidebar()">
        <span class="mdi mdi-menu"></span>
      </button>
    </div>
  </b-navbar>
</template>

<script lang="js">
import OrganisationMenu from '../OrganisationMenu'
export default {
  components: {
    OrganisationMenu
  },
  name: 'app-header',
  methods: {
    collapedMobileSidebar: () => {
      document.querySelector('.sidebar').classList.toggle('active')
    },
    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-header {
}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppHeader.vue